module.exports = __webpack_public_path__ + "static/media/1.8b49010a.jpg";